import type { Node as ProsemirrorNode } from "prosemirror-model";

import { mergeAttributes, Node } from "@tiptap/core";
import { IntegrationTokenNode } from "@v2/features/chat/components/chat-elements/message-input/IntegrationTokenNode";
import { serializeChatTokenPayload } from "@v2/features/chat/utils/chatTokenSerialization";

interface MarkdownSerializerState {
  text: (text: string, escape?: boolean) => void;
}

export default Node.create({
  name: "integrationComponent",

  group: "inline",

  inline: true,

  selectable: false,
  atom: true,

  parseHTML() {
    return [
      {
        tag: "integration-component",
      },
    ];
  },

  addAttributes() {
    return {
      data: {
        default: null,
        parseHTML: (element) => {
          const dataAttr = element.getAttribute("data");
          if (!dataAttr) {
            return null;
          }
          try {
            return JSON.parse(dataAttr);
          } catch {
            return null;
          }
        },
        renderHTML: (attributes) => {
          if (!attributes.data) {
            return {};
          }
          return {
            data: JSON.stringify(attributes.data),
          };
        },
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ["integration-component", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return IntegrationTokenNode;
  },

  addStorage() {
    return {
      markdown: {
        serialize: (state: MarkdownSerializerState, node: ProsemirrorNode) => {
          /*
           * NOTE (Kevin 2025-09-24): Persist integration nodes as <chat-token> so the
           * markdown pipeline can round-trip them into ChatToken components when we
           * render history.
           */
          const token = serializeChatTokenPayload(
            "integration",
            node.attrs.data,
          );
          if (token) {
            state.text(token, false);
          }
        },
      },
    };
  },
});
